import * as React from 'react';
import {useState} from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';

const marks = [{
	value: 0, label: '1mile',
}, {
	value: 13, label: '5',
}, {
	value: 26, label: '10',
}, {
	value: 39, label: '20',
}, {
	value: 50, label: '30',
}, {
	value: 65, label: '50',
}, {
	value: 75, label: '100',
}, {
	value: 85, label: '200',
}, {
	value: 92, label: '300',
}, {
	value: 100, label: '1400',
}
];

function valuetext(value) {
	return `${value}`;
}

function valueLabelFormat(value) {
	return marks.findIndex((mark) => mark.value === value) + 1;
}

export default function DiscreteSliderValues({getAndSetCurrentDistanceValue}) {
	const [sliderValue, setSliderValue] = useState(39); // Default value of 50
	const getLabelByValue = (value) => {
		const mark = marks.find(mark => mark.value === value);
		return mark ? mark.label : 'Label not found';
	};
	
	const handleSliderChange = (event, newValue) => {
		setSliderValue(newValue);
		let actualValue = getLabelByValue(newValue)
		actualValue = actualValue.replace('mile', '')
		getAndSetCurrentDistanceValue(actualValue);
	};
	
	return (<div style={{marginLeft: "50px", marginTop: "40px"}}>
		<div style={{display: "flex"}}>Filter By Distance
			<Box sx={{width: 500}} style={{marginLeft: "50px", marginTop: "-4px"}}>
				<Slider
					aria-label="Restricted values"
					defaultValue={sliderValue}
					valueLabelFormat={valueLabelFormat}
					getAriaValueText={valuetext}
					step={null}
					valueLabelDisplay="auto"
					marks={marks}
					onChange={handleSliderChange}
				/>
			</Box>
		</div>
	</div>);
}